// @ts-check
import { addClass, getAttr, query, queryAll, removeClass, setAttr } from 'matt-utils';

/**
 * Fetch next page
 */
export class CollNext extends HTMLElement {

  #fetching = false;

  /**
   * Elemento connesso
   */
  connectedCallback() {

    const _this = this;

    this.#fetching = false;

    this.intObs = new IntersectionObserver( ( entries ) => {
      entries.forEach( ( entry ) => {

        if ( !entry.isIntersecting )
          return;

        _this._fetchPage();

      });
    });

    this.intObs.observe( query( '.coll__loader-wrap', this ) );

  }

  /**
   * Elemento disconnesso
   */
  disconnectedCallback() {

    this.intObs?.disconnect();

  }

  /**
   * Fetch pagina successiva
   */
  _fetchPage() {

    if ( this.#fetching )
      return;

    this.#fetching = true;

    const loader = query( '.coll__loader-wrap', this ),
      btnNext    = query( '.coll__loader-a', this ),
      href       = getAttr( btnNext, 'href' ) ?? '';

    if ( href === '' )
      return;

    addClass( loader, 'loading' );

    const _this = this;

    fetch( href, {
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      method:      'GET',
    })
      .then( ( res ) => res.text() )
      .then( ( res ) => {

        const newHtml = document.createElement( 'html' );
        newHtml.innerHTML = res;

        queryAll( '.card__prod-card', newHtml ).forEach( ( el ) => {
          query( '#coll__list' ).appendChild( el );
        });

        removeClass( loader, 'loading' );

        setAttr( btnNext, 'href', getAttr( query( '.coll__loader-a', newHtml ), 'href' ) );

        removeClass( loader, 'loading' );
        _this.replaceWith( query( 'coll-next', newHtml ) );

        newHtml.remove();

        _this.#fetching = false;

      });

  }
}

customElements.define( 'coll-next', CollNext );